module.exports = __webpack_public_path__ + "img/money.c1b3d97.svg";